import React, { useState, useEffect, useRef, useCallback } from 'react';

interface CountdownTimerProps {
  totalMilliseconds: number; // 后端返回的总毫秒数
  className?: string;
  onExpire?: () => void; // 倒计时结束回调
  warningThreshold?: number; // 警告阈值(毫秒)，默认5分钟
  isshowWarning?: boolean; // 是否显示警告
  props?: string; //传入内容
}

export default function CountdownTimer({
  totalMilliseconds,
  className,
  onExpire,
  warningThreshold = 5 * 60 * 1000,
  isshowWarning = false,
  props = '链接失效时间:',
}: CountdownTimerProps) {
  // 状态管理
  const [remainingMs, setRemainingMs] = useState(totalMilliseconds);
  const [isExpired, setIsExpired] = useState(totalMilliseconds <= 0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  // 格式化时间函数
  const formatTime = (milliseconds: number) => {
    if (milliseconds <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      };
    }

    const days = Math.floor(milliseconds / (24 * 60 * 60 * 1000));
    const hours = Math.floor((milliseconds % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    const minutes = Math.floor((milliseconds % (60 * 60 * 1000)) / (60 * 1000));
    const seconds = Math.floor((milliseconds % (60 * 1000)) / 1000);
    const ms = Math.floor(milliseconds % 1000);

    return { days, hours, minutes, seconds, milliseconds: ms };
  };

  // 计算时间格式化
  const timeLeft = formatTime(remainingMs);

  // 是否显示警告
  const showWarning = isshowWarning && remainingMs > 0 && remainingMs <= warningThreshold;

  // 清理定时器
  const clearTimer = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  // 设置倒计时定时器
  useEffect(() => {
    // 如果已经过期，不启动定时器
    if (isExpired) return;

    // 启动定时器
    timerRef.current = setInterval(() => {
      setRemainingMs((prev) => {
        const newMs = prev - 100; // 每100ms更新一次
        // 检查是否过期
        if (newMs <= 0) {
          clearTimer();
          setIsExpired(true);
          onExpire?.();
          return 0;
        }

        return newMs;
      });
    }, 100);

    // 组件卸载时清理
    return () => {
      clearTimer();
    };
  }, [isExpired, clearTimer, onExpire]);

  // 格式化数字为两位数
  const formatNumber = (num: number) => num.toString().padStart(2, '0');

  return (
    <div className="d-flex-c">
      {showWarning && (
        <div className="animated-element text-center text-color-white mb-10 font-size-14 font-widget-600">
          链接即将失效
        </div>
      )}
      {/* <div className={`countdown-box ${className || ''} ${isExpired ? 'opacity-50' : ''}`}>
        <span>{0}</span>天<span>{formatNumber(timeLeft.hours)}</span>时<span>{formatNumber(timeLeft.minutes)}</span>分
        <span>{formatNumber(timeLeft.seconds)}</span>秒
      </div> */}
      <div className={`font-size-12 mt-2 ${className}`}>
        {props}
        {formatNumber(timeLeft.hours)}：{formatNumber(timeLeft.minutes)}：{formatNumber(timeLeft.seconds)}
      </div>
    </div>
  );
}
